/**
 * Horizontal-scroll rows: click-to-scroll via [data-carousel-prev]/[data-carousel-next]
 * buttons, mouse-drag-to-scroll, and no scroll-wheel-driven horizontal movement.
 * Touch devices keep their native swipe scrolling. Applies to every horizontally-
 * scrolling row in the theme (product/testimonial/brand carousels, category rows,
 * the category nav, and the PPF booking stepper).
 */
(function () {
  var ROW_SELECTOR = [
    '[data-carousel-track]',
    '.category-nav__list',
    '.hero-ppf__side-cards',
    '.category-quick',
    '.ppf-booking__stepper'
  ].join(', ');

  function initButtons(track) {
    var wrapper = track.parentElement;
    var prevBtn = wrapper.querySelector('[data-carousel-prev]');
    var nextBtn = wrapper.querySelector('[data-carousel-next]');
    var scrollAmount = function () { return track.clientWidth * 0.8; };

    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    var progress = wrapper.querySelector('[data-carousel-progress]');
    if (progress) progress.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-page]');
      if (dot) track.scrollTo({ left: Number(dot.dataset.page) * track.clientWidth, behavior: 'smooth' });
    });

    function renderProgress() {
      if (!progress) return;
      var pages = track.clientWidth ? Math.ceil(track.scrollWidth / track.clientWidth) : 1;
      if (pages <= 1) { progress.innerHTML = ''; return; }
      var current = Math.min(pages - 1, Math.round(track.scrollLeft / track.clientWidth));
      if (progress.childElementCount !== pages) {
        progress.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel-progress__dot';
          dot.dataset.page = i;
          dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
          progress.appendChild(dot);
        }
      }
      Array.prototype.forEach.call(progress.children, function (dot, i) {
        dot.classList.toggle('is-current', i === current);
      });
    }

    function updateEdges() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll - 1;
      wrapper.classList.toggle('is-at-start', atStart);
      wrapper.classList.toggle('is-at-end', atEnd);
      wrapper.classList.toggle('is-no-overflow', maxScroll <= 1);
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
      renderProgress();
    }
    track.addEventListener('scroll', updateEdges, { passive: true });
    window.addEventListener('resize', updateEdges);
    updateEdges();
  }

  function initDrag(el) {
    var isDown = false, dragged = false, startX = 0, startScroll = 0;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      isDown = true;
      dragged = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      el.classList.add('is-dragging');
    });
    el.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 4) dragged = true;
      el.scrollLeft = startScroll - delta;
    });
    function stopDrag() {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');
    }
    el.addEventListener('pointerup', stopDrag);
    el.addEventListener('pointercancel', stopDrag);
    el.addEventListener('pointerleave', stopDrag);
    el.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true);
  }

  function initWheelBlock(el) {
    el.addEventListener('wheel', function (e) {
      if (el.scrollWidth <= el.clientWidth) return;
      e.preventDefault();
      window.scrollBy(0, e.deltaY);
    }, { passive: false });
  }

  function initCentering(el) {
    function update() {
      el.classList.toggle('is-centered', el.scrollWidth <= el.clientWidth + 1);
    }
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(el);
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-carousel-track]').forEach(initButtons);
    document.querySelectorAll(ROW_SELECTOR).forEach(function (el) {
      initDrag(el);
      initWheelBlock(el);
      initCentering(el);
    });
  });
})();
